import axios from 'axios'

const apiExternalUrl = axios.create()

apiExternalUrl.defaults.withCredentials = false

export default apiExternalUrl
